export default __webpack_public_path__ + "static/media/Mask of the Ghost of the Veldt.c62bc00c.jpg";